// TODO: This is only partially started based on posts and profiles
// TODO: Decide if handle this like a profile, like a post, or as just a form
// TODO: Depending how this is handled, we might need special roles in the system for organizer - for example, would we want to risk all organizers being able to edit all location records? no. So then you'd need organizer and member of placename.
// Placename could be manually added for the first year while we're small enough to manually add their local Bloom membership affiliation - ideally it's pulled from their nft metadata with a field that we collect on signup inside that, similar to how we check their wallet data
// Organizer could also be manually checked in the db
// So, if member placename && organizer then can edit

import { imageBucket, avatarBucket, locationTable } from '$lib/supabase';
import type { LocationAttrs, ProjectsArray } from './location.type';
import { validate as uuidValidate } from 'uuid';
import { locationOwner, locationStore, locations } from '.';
import DOMPurify from 'dompurify';
import { getUser } from '$lib/utils/user';

const enableLogs = false;

const GET_COL_SET = '*'; // include all columns

const GET_LIMITED_COL_SET = [
	'id',
	'systemname',
	'placename',
	'created_at',
	'brandname',
	'website_url',
	'image_url',
	'description',
	'twitter',
	'insta',
	'linkedin',
	'projects',
	'email',
	'communitybuilder',
	'planner',
	'promoter',
	'treasurebuilder',
	'engineer',
	'storyteller',
	'storyteller_avatar',
	'locationowner',
	'communitybuilder_avatar',
	'planner_avatar',
	'promoter_avatar',
	'treasurebuilder_avatar',
	'engineer_avatar',
	'project_type',
	'published',
	'foodguru',
	'repairspecialist',
	'medicinehuman',
	'foodguru_avatar',
	'medicinehuman_avatar',
	'repairspecialist_avatar',
	'continent',
	'wallet',
	'impact_area',
	'comments',
	'stage'
].join(', ');

const GET_DIR_COL_SET = [
	'id',
	'systemname',
	'placename',
	'created_at',
	'brandname',
	'website_url',
	'image_url',
	'description',
	'twitter',
	'insta',
	'linkedin',
	'email',
	'locationowner',
	'published',
	'continent',
	'wallet',
	'stage'
].join(', ');

// /**
//  * createLocation - Creates a location record
//  *
//  * example: https://example.com/create/action the type is "action"
//  *
//  * @param <LocationAttrs>location - location object (see location.type.ts)
//  * @returns { data, error } where data is a single supabase post table object matching the location | false if err
//  *
//  * TODO: better validation of ID and return object
//  *
//  */
// export const createLocation = async (location: LocationAttrs) => {
// 	let _data, _error;
// 	{
// 		const { data, error } = await locationTable('locations').insert(location);
// 		_data = <unknown>data;
// 		_error = error;
// 	}
// 	// this is a trick to create a <PostgrestFilterBuilder> object if there's no matching record
// 	const data = _data;
// 	const error = _error;
// 	return { data, error };
// };

/**
 * createLocation - Creates a location of the given type for the current user
 *
 * example: https://example.com/create/action the type is "action"
 *
 * @param <LocationAttrs>location - location object (see location.type.ts)
 * @returns { data, error } where data is a single supabase location table object matching the location | false if err
 *
 * TODO: better validation of ID and return object
 *
 */
export const createLocation = async (location: LocationAttrs) => {
	let _error;
	// // let _data, _error;
	// console.log(location);
	// console.log(uuidValidate(location.locationowner));
	if (uuidValidate(location.locationowner)) {
		const result = await locationTable('locations').insert(location);
		// console.log('result ', result);
		// _data = <unknown>result.data;
		_error = result.status !== 201 ? result.statusText : undefined;
		// if the result is not 201 (means created). then the error will be what the server says the error is
	}
	// this is a trick to create a <PostgrestFilterBuilder> object if there's no matching record
	// const data = _data;
	const error = _error;
	return { error };
};

// /**
//  * getUser - Get current user's session
//  *
//  * @returns { user } supabase session object
//  *
//  */
// export const getRole = async () => {
// 	const user = await getUser();
// 	console.log('locallead, ', user.locallead);
// 	// this is returning undefined
// 	return user.locallead;
// };
// session does not appear to retun anything other than id.... workaround for now would be to place the id of the locallead member (we'll have that as soon as we invite them, into the location table, and run that similar to postOwner in voidCanEdit...)

// TODO: THIS PROBABLY NEEDS DIFFERENT LOGIC - (IS BASED ON POST EDITOR) - IF USER IS ADMIN || (LOCALLEAD (BOOL) && LOCAL BLOOM IS ____), CAN EDIT
/**
 * voidCanEditLocation - Checks if a user can edit location and stores bool to locationOwner store
 *
 * @param <LocationAttrs>location - the location to edit
 * @returns void - nada! Stores a bool to locationOwner store.
 *
 * TODO: better return object error handling
 *
 */
export const voidCanEditLocation = async (location: LocationAttrs) => {
	// validate uuid
	const valid = uuidValidate(location.locationowner);
	// you can't uuidValidate something that's not the id field
	// console.log(location.locationowner);
	// locationowner is correct, but valid is returning as always true
	if (valid) {
		// check if user is locationowner - or if user is admn
		if (location.locationowner == getUser().id) {
			locationOwner.set(true); // set store true
		} else {
			// user didn't create location
			locationOwner.set(false);
		}
	} else {
		locationOwner.set(false);
	}
};

// TODO: delete this?
export const updCurrLocationProfile = (attrs: LocationAttrs) =>
	locationTable('locations')
		.upsert({
			...attrs,
			id: getUser()!.id,
			updated_at: new Date()
		})
		.select();

// /**
//  * getLocationId - Get a location with the given systemname (example: fortcollins)
//  *
//  * @param <string>id - ID of location to get
//  * @returns { data, error } where data is a single supabase location table object
//  *
//  * TODO: better validation of ID and return object
//  *
//  */
// export const getLocationId = (id: string) =>
// 	locationTable('locations').select(GET_COL_SET).eq('id', id).single();

export const getLocationProfile = (id: string) =>
	locationTable('locations').select(GET_LIMITED_COL_SET).eq('id', id).single();

// TODO: Delete this? How to get the id of this location row, or create one with the form?
// location.systemname;
export const getCurrLocationProfile = (id: string) => getLocationProfile(id);

export const getApplicationDetails = (profileId: string) =>
	locationTable('locations') // Use the appropriate table name
		.select(GET_COL_SET) // Select all columns; adjust as needed
		.eq('locationowner', profileId); // Filter by the application ID

// Get a location with the given systemname (example: fortcollins) and load it into the store
export const getLocation = async (location: LocationAttrs) => {
	try {
		if (!location.id) {
			console.warn('No location ID provided');
			return;
		}

		const { data, error: queryError } = await getCurrLocationProfile(location.id);
		if (queryError) throw queryError;
		if (!data || typeof data === 'string') return;

		const locationData = data as LocationAttrs;

		// Process avatars if they exist
		if (locationData.storyteller_avatar) {
			locationData.storyteller_avatar = await getRoleAvatar(locationData.storyteller_avatar);
		}
		if (locationData.communitybuilder_avatar) {
			locationData.communitybuilder_avatar = await getRoleAvatar(
				locationData.communitybuilder_avatar
			);
		}
		if (locationData.planner_avatar) {
			locationData.planner_avatar = await getRoleAvatar(locationData.planner_avatar);
		}
		if (locationData.promoter_avatar) {
			locationData.promoter_avatar = await getRoleAvatar(locationData.promoter_avatar);
		}
		if (locationData.treasurebuilder_avatar) {
			locationData.treasurebuilder_avatar = await getRoleAvatar(
				locationData.treasurebuilder_avatar
			);
		}
		if (locationData.engineer_avatar) {
			locationData.engineer_avatar = await getRoleAvatar(locationData.engineer_avatar);
		}
		if (locationData.image_url) {
			locationData.image_url = await getLocationAvatar(locationData.image_url);
		}
		locationStore.set(locationData);
	} catch (error) {
		if (error instanceof TypeError) {
			/* ignored as the user is signed out*/
		} else console.log('location.api.ts:getLocation:error', error);
	}
};

/**
 *	setLocationSystemname():  updates the Local Bloom's systemname for their Local Bloom page
 * @param id <UUIDv4> ID of the Local Bloom to update systemname for
 * @param systemname <string>:  The systemname this local bloom uses
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationSystemname = async (id: string, systemname: string) => {
	if (enableLogs) console.log('setLocationSystemname:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(systemname);

	if (valid) {
		if (enableLogs) console.log('setLocationSystemname:ID:valid');
		const retVal = locationTable('locations')
			.update({ systemname: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setLocationSystemname:ID:invalid');
		return false;
	}
};

/**
 * setLocationProjectType ; Sets project type(s) of initial location starter's project
 *
 * @param id <string> The UUID of the post to update
 * @param project_type<Array> participants in an action
 * @returns <PostgrestFilterBuilder> object of the Supabase PostgreSQL query | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationProjectType = async (id: string, project_type: Array<string>) => {
	// console.log('setLocationProjectType:', id, project_type);
	const valid = uuidValidate(id);

	if (project_type.length === 0) {
		// The project_type array is empty, so you might want to handle this case.
		// You can throw an error, return a specific error response, or take appropriate action.
		return { error: 'project_type array is empty' };
	}
	if (valid) {
		// console.log('setLocation: Valid UUID');
		const retVal = locationTable('locations')
			.update({ project_type: project_type })
			.match({ id: id })
			.select();

		// console.log('retVal', retVal);
		return retVal;
	} else {
		// console.log('setLocation: ID not a valid UUID');
		return false;
	}
};

/**
 *	setLocationPlaceName():  updates the Local Bloom's placename for their Local Bloom page
 * @param id <UUIDv4> ID of the Local Bloom to update realname for
 * @param placename <string>:  The placename this local bloom uses
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationPlaceName = async (id: string, placename: string) => {
	if (enableLogs) console.log('setLocationPlaceName:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(placename);

	if (valid) {
		if (enableLogs) console.log('setLocationPlaceName:ID:valid');
		const retVal = locationTable('locations')
			.update({ placename: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setLocationPlaceName:ID:invalid');
		return false;
	}
};

/**
 * getLocations - Gets aall locations
 *
 * @param <number>limit - no parameters
 * @returns { data, error } where data is a list of supabase post table objects
 *
 * TODO: better validation of ID and return object
 *
 */
export const getLocations = async (page: number, pageSize: number) => {
	const { data, error: downloadError } = await locationTable('locations')
		.select(GET_DIR_COL_SET)
		.eq('published', true)
		.order('placename', { ascending: true })
		.range(page * pageSize, (page + 1) * pageSize - 1);

	if (downloadError) {
		console.error('Error fetching locations:', downloadError);
		throw downloadError; // This will be caught in your component
	}

	locations.update((location) => {
		for (let i = 0; i < data.length; i++) {
			location.push(data[i]);
		}
		if (downloadError) {
			throw downloadError;
		}
		return location;
	});
};

/**
 * getSystemname - Gets systemname from placename
 *
 * @param <number>limit - no parameters
 * @returns { data, error } where data is a list of supabase post table objects
 *
 * TODO: better validation of ID and return object
 *
 */
export const getSystemname = async (placename: string) => {
	// console.log('placename', placename);

	if (placename === 'Bloom International') {
		return 'international';
	}
	const { data, error: downloadError } = await locationTable('locations')
		.select('systemname')
		.eq('placename', placename)
		.limit(1);
	if (downloadError) {
		throw downloadError;
	}
	// console.log('data', data);
	// Extract the systemname from the first result if data is not empty
	const systemname = data.length > 0 ? data[0].systemname : null;
	return systemname;
};

/**
 * getPlacenameFromSystemname - Gets placemname from systemname
 *
 * @param <number>limit - no parameters
 * @returns { data, error } where data is a list of supabase post table objects
 *
 * TODO: better validation of ID and return object
 *
 */
export const getPlacenameFromSystemname = async (systemname: string) => {
	// console.log('placename', placename);

	if (systemname === 'Bloom International') {
		return 'international';
	}
	const { data, error: downloadError } = await locationTable('locations')
		.select('placename')
		.eq('systemname', systemname)
		.limit(1);
	if (downloadError) {
		throw downloadError;
	}
	// console.log('data', data);
	// Extract the systemname from the first result if data is not empty
	const placename = data.length > 0 ? data[0].placename : null;
	return placename;
};

/**
 * getPlacenames - Gets placenames of all locations
 *
 * @param <number> page - Page number
 * @param <number> pageSize - Number of items per page
 * @returns { data, error } where data is a list of placenames
 *
 * TODO: better validation of ID and return object
 *
 */
export const getPlacenames = async (page: number, pageSize: number) => {
	const { data, error: downloadError } = await locationTable('locations')
		.select('placename') // Only select the 'placename' column
		.eq('published', true)
		.order('placename', { ascending: true })
		.range(page * pageSize, (page + 1) * pageSize - 1);
	const localblooms = data.map((row) => row.placename);
	if (downloadError) {
		throw downloadError;
	}
	// console.log(localblooms);
	return localblooms;
};

/**
 *
 * @param url <string> - the Supabase URL string of the image to fetch
 * @returns <string> - a URL object string that can be used in an <img src={getImageSm('someImage')}> tag
 *
 * TODO: string validation
 *       better return object error handling
 */
export const getLocationImage = async (url: string | null | undefined) => {
	if (url && typeof url === 'string' && url.trim() !== '') {
		return await getLocationAvatar(url);
	}
	return '/img/bloomMapIcon2Square.png';
};
// TODO: return an image not a blob, so supabase can render a webp: https://supabase.com/docs/guides/storage/image-transformations#automatic-image-optimisation-webp

/**
 *
 * @param url <string> - the Supabase URL string of the image to fetch
 * @returns <string> - a URL object string that can be used in an <img src={getImage('someImage')}> tag
 *
 * TODO: string validation
 *       better return object error handling
 */
export const getImage = async (url: string) => {
	const { data, error: downloadError } = await imageBucket('images').download(url);
	if (downloadError) {
		throw downloadError;
	}

	return URL.createObjectURL(data);
};

// TODO: This is duplicate/ish of updatedLocationImage
export const updLocationPhoto = async (file: File, id: string) => {
	// const valid = uuidValidate(location.id);
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await imageBucket('images').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}

	return await locationTable('locations').upsert({ id: id, image_url: filePath }).select();
};

export const getLocationPhoto = async (url: string) => {
	const { data, error: downloadError } = await imageBucket('images').download(url);
	if (downloadError) {
		throw downloadError;
	}

	return URL.createObjectURL(data);
};

/**
 *	setLocationBrandname():  updates the brandname for the local Bloom's page
 * @param id <UUIDv4> ID of the location to update Twitter for
 * @param brandname <string>: The local Bloom's brandname or collective name
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationBrandname = async (id: string, brandname: string) => {
	if (enableLogs) console.log('ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(brandname);

	if (valid) {
		if (enableLogs) console.log('Valid UUID');
		const retVal = locationTable('locations')
			.update({ brandname: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('ID not a valid UUID');
		return false;
	}
};

/**
 *	setLocationTwitter():  updates the twitter. URL for the local Bloom's page
 * @param id <UUIDv4> ID of the location to update Twitter for
 * @param twitter <string>: The local Bloom's primary Twitter link
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationTwitter = async (id: string, twitter: string) => {
	if (enableLogs) console.log('ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(twitter);

	if (valid) {
		if (enableLogs) console.log('Valid UUID');
		const retVal = locationTable('locations').update({ twitter: CLEAN }).match({ id: id }).select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('ID not a valid UUID');
		return false;
	}
};

/**
 *	setLocationInsta():  updates the instagram URL for the local Bloom's page
 * @param id <UUIDv4> ID of the user to update Instagram for
 * @param insta <string>: The local Bloom's instagram link
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationInsta = async (id: string, insta: string) => {
	if (enableLogs) console.log('ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(insta);

	if (valid) {
		if (enableLogs) console.log('Valid UUID');
		const retVal = locationTable('locations').update({ insta: CLEAN }).match({ id: id }).select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('ID not a valid UUID');
		return false;
	}
};

/**
 *	setLocationLinkedin():  updates the linkedin URL for the local Bloom's page
 * @param id <UUIDv4> ID of the user to update Linkedin for
 * @param linkedin <string>: The local Bloom's linkedin link
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationLinkedin = async (id: string, linkedin: string) => {
	if (enableLogs) console.log('ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(linkedin);

	if (valid) {
		if (enableLogs) console.log('Valid UUID');
		const retVal = locationTable('locations')
			.update({ linkedin: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('ID not a valid UUID');
		return false;
	}
};

/**
 *	setLocationWebsite_url():  updates the Local Bloom's website_url for their Local Bloom page
 * @param id <UUIDv4> ID of the Local Bloom to update website_url for
 * @param website_url <string>:  The website of this local bloom if they have their own website
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationWebsite_url = async (id: string, website_url: string) => {
	if (enableLogs) console.log('setLocationWebsite_url:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(website_url);

	if (valid) {
		if (enableLogs) console.log('setLocationWebsite_url:ID:valid');
		const retVal = locationTable('locations')
			.update({ website_url: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setLocationWebsite_url:ID:invalid');
		return false;
	}
};

/**
 *	setLocationSystemName():  updates the Local Bloom's systemname for their Local Bloom page
 * @param id <UUIDv4> ID of the Local Bloom to update systemname for
 * @param systemname <string>:  The systemname of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationSystemName = async (id: string, systemname: string) => {
	if (enableLogs) console.log('setLocationSystemName:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(systemname);

	if (valid) {
		if (enableLogs) console.log('setLocationSystemName:ID:valid');
		const retVal = locationTable('locations')
			.update({ systemname: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setLocationSystemName:ID:invalid');
		return false;
	}
};

// TODO: CHECK THIS IS WORKING
/**
 * getLocationBySystemName - Gets location by given URL slug
 *
 * example: https://example.com/local/diamante the slug is "some_post_name"
 *
 * @param <string>systemname - the URL slug matching the post
 * @returns { data, error } where data is a single supabase post table object matching the slug
 *
 * TODO: better validation of ID and return object
 *
 */
export const getLocationBySystemName = async (systemname: string) => {
	const { data, error } = await locationTable('locations')
		.select(GET_LIMITED_COL_SET)
		.eq('systemname', systemname)
		.single();

	if (error && error.code === '40P01') {
		// Error code '40P01' indicates no rows found
		return { data: null, error: { message: 'Location not found' } };
	}

	return { data, error };
};

/**
 * getPlacenameBySystemname - Gets placename from systemname by given URL slug
 *
 * example: https://example.com/local/diamante the slug is "some_post_name"
 *
 * @param <string>systemname - the URL slug matching the post
 * @returns {string} - the placename corresponding to the systemname
 *
 * TODO: better validation of ID and return object
 *
 */
export const getPlacenameBySystemname = async (systemname: string): Promise<string> => {
	try {
		const { data, error } = await locationTable('locations')
			.select('placename')
			.eq('systemname', systemname)
			.single();

		if (error) {
			if (error.code === '40P01') {
				// No rows found
				return 'Unknown Location';
			}
			throw new Error(error.message);
		}

		if (data) {
			return data.placename;
		} else {
			return 'Unknown Location';
		}
	} catch (err) {
		console.error('Error fetching placename:', err);
		return 'Unknown Location';
	}
};

/**
 *	setLocationDescription():  updates the Local Bloom's description for their Local Bloom page
 * @param id <UUIDv4> ID of the Local Bloom to update description for
 * @param description <string>:  The description of this local bloom
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationDescription = async (id: string, description: string) => {
	if (enableLogs) console.log('setLocationDescription:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(description);

	if (valid) {
		if (enableLogs) console.log('setLocationDescription:ID:valid');
		const retVal = locationTable('locations')
			.update({ description: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setLocationDescription:ID:invalid');
		return false;
	}
};

// This would be the approach if we move the roles into one column, see notes in location.type.ts
// /**
//  * setLocationRoles ; Sets location Roles object
//  * @param id <string> The UUID of the location to update
//  * @param roles <RolesArray> JSON roles array object
//  * @returns <PostgrestFilterBuilder> object of the Supabase PostgreSQL query | <boolean>false if error.
//  *
//  * TODO: validate profile ownership first? doing that sufficiently in editor before getting here.
//  *       better return object error handling
//  */
// export const setLocationRoles = async (id: string, roles: RolesArray) => {
// 	if (enableLogs) console.log('setLocationRoles:', id, roles);
// 	const valid = uuidValidate(id);
// 	const cleanString = sanitizeHtml(JSON.stringify(roles));
// 	const CLEAN = JSON.parse(cleanString);

// 	if (valid) {
// 		if (enableLogs) console.log('setLocationRoles: Valid UUID');
// 		const retVal = locationTable('locations').update({ roles: CLEAN }).match({ id: id }).select();

// 		if (enableLogs) console.log(retVal);
// 		return retVal;
// 	} else {
// 		if (enableLogs) console.log('setLocationRoles: ID not a valid UUID');
// 		return false;
// 	}
// };

/**
 * getPageByLocation - Gets page by given location (is a slug)
 *
 * example: https://example.com/local/locationname the location is "locationname"
 *
 * @param <string>systemname - the name of the location
 * @returns { data, error } where data is a single supabase post table object matching the slug
 *
 * TODO: better validation of ID and return object
 *
 */
export const getPageByLocation = (systemname: string) =>
	locationTable('locations').select(GET_LIMITED_COL_SET).eq('systemname', systemname).single();
// single means return data as a single object not an array of objects
// POSSIBLE BUG: does location need to be locations here in the paren for locationTable? it appears to be working ok

/**
 * setLocationProjects ; Sets location Projects object
 * @param id <string> The UUID of the profile to update
 * @param projects <ProjectsArray> JSON project array object
 * @returns <PostgrestFilterBuilder> object of the Supabase PostgreSQL query | <boolean>false if error.
 *
 * TODO: validate profile ownership first? doing that sufficiently in editor before getting here.
 *       better return object error handling
 */
export const setLocationProjects = async (id: string, projects: ProjectsArray) => {
	if (enableLogs) console.log('setProjects:', id, projects);
	const valid = uuidValidate(id);
	const cleanString = DOMPurify.sanitize(JSON.stringify(projects));
	const CLEAN = JSON.parse(cleanString);

	if (valid) {
		if (enableLogs) console.log('setProjects: Valid UUID');
		const retVal = locationTable('locations')
			.update({ projects: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setProjects: ID not a valid UUID');
		return false;
	}
};

/**
 * setLocationProjectsNoImage ; Sets location Projects object
 * @param id <string> The UUID of the profile to update
 * @param projects <ProjectsArray> JSON project array object
 * @returns <PostgrestFilterBuilder> object of the Supabase PostgreSQL query | <boolean>false if error.
 */
export const setLocationProjectsNoImage = async (id: string, projects: any) => {
	try {
		console.log('setProjects:', id, projects);
		const valid = uuidValidate(id);
		if (!valid) {
			console.error('setProjects: ID not a valid UUID');
			return false;
		}

		const cleanString = DOMPurify.sanitize(JSON.stringify(projects));
		const CLEAN = JSON.parse(cleanString);
		console.log('CLEAN', CLEAN);
		const { data, error } = await locationTable('locations')
			.update({ projects: CLEAN })
			.match({ id: id })
			.select();

		if (error) {
			console.error('setProjects: Error updating projects', error);
			return false;
		}

		if (enableLogs) {
			console.log('setProjects: Update successful', data);
		}

		return data;
	} catch (err) {
		console.error('setProjects: Unexpected error', err);
		return false;
	}
};

/**
 *	setStoryteller():  updates the name of the Local Bloom's storyteller
 * @param id <UUIDv4> ID of the Local Bloom to update storyteller for
 * @param storyteller <string>:  The lead storyteller of this local bloom
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setStoryteller = async (id: string, storyteller: string) => {
	if (enableLogs) console.log('setStoryteller:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(storyteller);

	if (valid) {
		if (enableLogs) console.log('setStoryteller:ID:valid');
		const retVal = locationTable('locations')
			.update({ storyteller: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setStoryteller:ID:invalid');
		return false;
	}
};

/**
 *	setCommunityBuilder():  updates the name of the Local Bloom's Community Builder
 * @param id <UUIDv4> ID of the Local Bloom to update Community Builder for
 * @param communitybuilder <string>:  The community Builder of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setCommunityBuilder = async (id: string, communitybuilder: string) => {
	if (enableLogs) console.log('setCommunityBuilder:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(communitybuilder);

	if (valid) {
		if (enableLogs) console.log('setCommunityBuilder:ID:valid');
		const retVal = locationTable('locations')
			.update({ communitybuilder: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setCommunityBuilder:ID:invalid');
		return false;
	}
};

/**
 *	setPlanner():  updates the name of the Local Bloom's Planner
 * @param id <UUIDv4> ID of the Local Bloom to update Planner for
 * @param planner <string>:  The Planner of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setPlanner = async (id: string, planner: string) => {
	if (enableLogs) console.log('setPlanner:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(planner);

	if (valid) {
		if (enableLogs) console.log('setPlanner:ID:valid');
		const retVal = locationTable('locations').update({ planner: CLEAN }).match({ id: id }).select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setPlanner:ID:invalid');
		return false;
	}
};

/**
 *	setPromoter():  updates the name of the Local Bloom's promoter
 * @param id <UUIDv4> ID of the Local Bloom to update promoter for
 * @param promoter <string>:  The promoter of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setPromoter = async (id: string, promoter: string) => {
	if (enableLogs) console.log('setPromoter:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(promoter);

	if (valid) {
		if (enableLogs) console.log('setPromoter:ID:valid');
		const retVal = locationTable('locations')
			.update({ promoter: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setPromoter:ID:invalid');
		return false;
	}
};

/**
 *	setTreasureBuilder():  updates the name of the Local Bloom's treasurebuilder
 * @param id <UUIDv4> ID of the Local Bloom to update treasurebuilder for
 * @param treasurebuilder <string>:  The treasurebuilder of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setTreasureBuilder = async (id: string, treasurebuilder: string) => {
	if (enableLogs) console.log('setTreasureBuilder:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(treasurebuilder);

	if (valid) {
		if (enableLogs) console.log('setTreasureBuilder:ID:valid');
		const retVal = locationTable('locations')
			.update({ treasurebuilder: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setTreasureBuilder:ID:invalid');
		return false;
	}
};

/**
 *	setEngineer():  updates the name of the Local Bloom's engineer
 * @param id <UUIDv4> ID of the Local Bloom to update engineer for
 * @param engineer <string>:  The engineer of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setEngineer = async (id: string, engineer: string) => {
	if (enableLogs) console.log('setEngineer:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(engineer);

	if (valid) {
		if (enableLogs) console.log('setEngineer:ID:valid');
		const retVal = locationTable('locations')
			.update({ engineer: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setEngineer:ID:invalid');
		return false;
	}
};

/**
 *	setMedicineHuman():  updates the name of the Local Bloom's MedicineHuman
 * @param id <UUIDv4> ID of the Local Bloom to update MedicineHuman for
 * @param medicinehuman <string>:  The medicinehuman of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setMedicineHuman = async (id: string, medicinehuman: string) => {
	if (enableLogs) console.log('setMedicineHuman:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(medicinehuman);

	if (valid) {
		if (enableLogs) console.log('setMedicineHuman:ID:valid');
		const retVal = locationTable('locations')
			.update({ medicinehuman: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setMedicineHuman:ID:invalid');
		return false;
	}
};

/**
 *	setFoodGuru():  updates the name of the Local Bloom's FoodGuru
 * @param id <UUIDv4> ID of the Local Bloom to update FoodGuru for
 * @param foodguru <string>:  The FoodGuru of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setFoodGuru = async (id: string, foodguru: string) => {
	if (enableLogs) console.log('setFoodGuru:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(foodguru);

	if (valid) {
		if (enableLogs) console.log('setFoodGuru:ID:valid');
		const retVal = locationTable('locations')
			.update({ foodguru: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setFoodGuru:ID:invalid');
		return false;
	}
};

/**
 *	setRepairSpecialist():  updates the name of the Local Bloom's RepairSpecialist
 * @param id <UUIDv4> ID of the Local Bloom to update RepairSpecialist for
 * @param repairspecialist <string>:  The RepairSpecialist of this local bloom - example diamante
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setRepairSpecialist = async (id: string, repairspecialist: string) => {
	if (enableLogs) console.log('setRepairSpecialist:ID', id);
	const valid = uuidValidate(id);
	const CLEAN = DOMPurify.sanitize(repairspecialist);

	if (valid) {
		if (enableLogs) console.log('setRepairSpecialist:ID:valid');
		const retVal = locationTable('locations')
			.update({ repairspecialist: CLEAN })
			.match({ id: id })
			.select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setRepairSpecialist:ID:invalid');
		return false;
	}
};

export const getLocationAvatar = async (url: string) => {
	const { data, error: downloadError } = await imageBucket('images').download(url, {
		transform: {
			width: 200,
			height: 200
		}
	});
	if (downloadError) {
		throw downloadError;
	}

	return URL.createObjectURL(data);
};

export const getProjectAvatar = async (url: string) => {
	const { data, error: downloadError } = await imageBucket('images').download(url, {
		transform: {
			width: 320,
			height: 144
		}
	});
	if (downloadError) {
		throw downloadError;
	}

	return URL.createObjectURL(data);
};

export const getRoleAvatar = async (url: string) => {
	const { data, error: downloadError } = await avatarBucket('avatars').download(url, {
		transform: {
			width: 200,
			height: 200
		}
	});
	if (downloadError) {
		throw downloadError;
	}

	return URL.createObjectURL(data);
};

// TODO: is it possible to simplify this to one const: updCurrRoleAvatar, so that the upsert uses a variable to assign which column to upload it into? If not, is it possible to batch the role information into a single column as an array, to reduce code length?

export const updCurrLocationImage = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await imageBucket('images').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	return await locationTable('locations').upsert({ id: id, image_url: filePath }).select();
};

export const updCurrStorytellerAvatar = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await avatarBucket('avatars').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	// console.log('filepath', filePath);
	return await locationTable('locations').upsert({ id: id, storyteller_avatar: filePath }).select();
};

export const updCurrCommunityBuilderAvatar = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await avatarBucket('avatars').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	return await locationTable('locations')
		.upsert({ id: id, communitybuilder_avatar: filePath })
		.select();
};

export const updCurrPlannerAvatar = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await avatarBucket('avatars').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	return await locationTable('locations').upsert({ id: id, planner_avatar: filePath }).select();
};

export const updCurrPromoterAvatar = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await avatarBucket('avatars').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	return await locationTable('locations').upsert({ id: id, promoter_avatar: filePath }).select();
};

export const updCurrTreasureBuilderAvatar = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await avatarBucket('avatars').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	return await locationTable('locations')
		.upsert({ id: id, treasurebuilder_avatar: filePath })
		.select();
};

export const updCurrEngineerAvatar = async (id: string, file: File) => {
	const fileExt = file.name.split('.').pop();
	const fileName = `${id}${Math.random()}.${fileExt}`;
	const filePath = `${fileName}`;

	const { error: uploadError } = await avatarBucket('avatars').upload(filePath, file);
	if (uploadError) {
		throw uploadError;
	}
	return await locationTable('locations').upsert({ id: id, engineer_avatar: filePath }).select();
};

/**
 * setLocationDetails: Updates the details of a Local Bloom location
 * @param id <UUIDv4> ID of the Local Bloom to update
 * @param locationDetails <object>: An object containing all the fields to update
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 *
 * TODO: better return object error handling
 */
export const setLocationDetails = async (id: string, locationDetails: Partial<LocationAttrs>) => {
	if (!id) {
		throw new Error('Location ID is required');
	}

	const valid = uuidValidate(id);
	if (!valid) {
		throw new Error('Invalid location ID');
	}

	try {
		const result = await locationTable('locations')
			.update({
				// ... rest of the update logic ...
			})
			.match({ id })
			.select();

		if (result.error) throw result.error;
		return result.data?.[0];
	} catch (error) {
		console.error('Error updating location details:', error);
		throw error;
	}
};

/**
 * setSection1Details: Creates or updates a location record for a Local Bloom location
 * @param id <UUIDv4> ID of the Local Bloom to create or update
 * @param placename <string>: The place name
 * @param brandname <string>: The brand name
 * @param continent <string>: The continent name
 * @param applicant <string>: the person applying
 * @param applicant_social <string>: the person applying's social links
 * @param locationowner <string>: the person applying's id
 * @returns { data, error } where data is the result from Supabase or false if error
 */
export const setSection1Details = async (
	id: string,
	placename: string,
	continent: string,
	applicant: string,
	applicant_social: string,
	locationowner: string
) => {
	if (enableLogs) console.log('setSection1Details:ID', id, placename, continent, locationowner);

	// Validate UUID
	if (!id || !uuidValidate(id)) {
		console.log('Invalid ID:', id);
		return false; // Stop execution if ID is null or invalid
	}

	// Get current timestamp
	const created_at = new Date().toISOString();

	// Sanitize inputs
	const CLEAN = {
		id, // Include the ID for update/insert
		placename: DOMPurify.sanitize(placename),
		continent: DOMPurify.sanitize(continent),
		applicant: DOMPurify.sanitize(applicant),
		applicant_social: DOMPurify.sanitize(applicant_social),
		locationowner: locationowner,
		created_at: created_at
	};
	if (enableLogs) console.log('CLEAN', CLEAN);

	try {
		// Check if record exists
		const { data: existingRecord, error: fetchError } = await locationTable('locations')
			.select('id, created_at')
			.eq('id', id)
			.single();

		if (enableLogs) console.log('data', existingRecord);

		if (fetchError && fetchError.code !== 'PGRST116') {
			if (enableLogs) console.log('Error checking existing record:', fetchError);
			return false;
		}

		let result;
		if (existingRecord) {
			// Update existing record but preserve original created_at
			const updateData = { ...CLEAN } as Partial<typeof CLEAN>;
			delete updateData.created_at;
			result = await locationTable('locations').update(CLEAN).eq('id', id).select();
			if (enableLogs) console.log('Record updated:', result);
		} else {
			// Insert new record
			result = await locationTable('locations').insert(CLEAN).select();
			if (enableLogs) console.log('New record created:', result);
		}

		if (result.error) {
			if (enableLogs) console.log('Error creating/updating record:', result.error);
			return false;
		}

		return result.data;
	} catch (error) {
		if (enableLogs) console.log('Exception in setSection1Details:', error);
		return false;
	}
};

/**
 * setSection2Details: Updates the details of Section 2 for a Local Bloom location
 * @param id <UUIDv4> ID of the Local Bloom to update
 * @param description <string>: Description of the location
 * @param impact_area <string>: Area of impact
 * @param project_type Array<string>: Type of project
 * @param website_url <string>: Website URL
 * @param image_url <string>: Image URL
 * @param twitter <string>: Twitter handle
 * @param insta <string>: Instagram handle
 * @param linkedin <string>: LinkedIn profile URL
 * @param projects <Project[]>: Projects related to the location
 * @param email <string>: Email address
 * @param wallet <string>: Wallet address
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 */
export const setSection2Details = async (
	id: string,
	description: string,
	impact_area: string,
	project_type: Array<string>,
	website_url: string,
	image_url: string,
	twitter: string,
	insta: string,
	linkedin: string,
	email: string,
	wallet: string
) => {
	if (enableLogs) console.log('setSection2Details:ID', id);

	if (!id || !uuidValidate(id)) {
		console.log('Invalid ID:', id);
		return false; // Stop execution if ID is null or invalid
	}

	const CLEAN = {
		description: DOMPurify.sanitize(description),
		impact_area: DOMPurify.sanitize(impact_area),
		project_type: `{${project_type.map((type) => DOMPurify.sanitize(type)).join(',')}}`,
		website_url: DOMPurify.sanitize(website_url),
		image_url: DOMPurify.sanitize(image_url),
		twitter: DOMPurify.sanitize(twitter),
		insta: DOMPurify.sanitize(insta),
		linkedin: DOMPurify.sanitize(linkedin),
		email: DOMPurify.sanitize(email),
		wallet: DOMPurify.sanitize(wallet)
	};

	if (enableLogs) console.log('setSection2Details:ID:valid');
	const retVal = locationTable('locations').update(CLEAN).match({ id: id }).select();

	if (enableLogs) console.log(retVal);
	return retVal;
};

/**
 * setSection3Details: Updates the details of Section 3 for a Local Bloom location
 * @param id <UUIDv4> ID of the Local Bloom to update
 * @param communitybuilder <string>: Community builder flag
 * @param planner <string>: Planner flag
 * @param promoter <string>: Promoter flag
 * @param treasurebuilder <string>: Treasure builder flag
 * @param engineer <string>: Engineer flag
 * @param storyteller <string>: Storyteller flag
 * @param medicinehuman <string>: Medicine human flag
 * @param foodguru <string>: Food guru flag
 * @param repairspecialist <string>: Repair specialist flag
 * @param team_emails <string>: Array of teammate emails
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 */
export const setSection3Details = async (
	id: string,
	communitybuilder: string,
	planner: string,
	promoter: string,
	treasurebuilder: string,
	engineer: string,
	storyteller: string,
	medicinehuman: string,
	foodguru: string,
	repairspecialist: string,
	team_emails: string
) => {
	if (enableLogs) console.log('setSection3Details:ID', id);

	const valid = uuidValidate(id);

	const CLEAN = {
		communitybuilder,
		planner,
		promoter,
		treasurebuilder,
		engineer,
		storyteller,
		medicinehuman,
		foodguru,
		repairspecialist,
		team_emails
	};

	if (valid) {
		if (enableLogs) console.log('setSection3Details:ID:valid');
		const retVal = locationTable('locations').update(CLEAN).match({ id: id }).select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setSection3Details:ID:invalid');
		return false;
	}
};

/**
 * setSection5Details: Updates the details of Section 5 for a Local Bloom location
 * @param id <UUIDv4> ID of the Local Bloom to update
 * @param readIntro <boolean>: Read introduction flag
 * @param understandPlatform <boolean>: Understand platform flag
 * @param signNameAgreement <boolean>: Signed name agreement flag
 * @param alignedWithBloom <boolean>: Aligned with Bloom flag
 * @param postMonthly <boolean>: Post monthly flag
 * @param attendCalls <boolean>: Attend calls flag
 * @param communityVolunteer <boolean>: Community volunteer flag
 * @param comments <string>: Additional comments
 * @returns <PostgrestFilterBuilder> | <boolean>false if error.
 */
export const setSection5Details = async (
	id: string,
	readIntro: boolean,
	understandPlatform: boolean,
	signNameAgreement: boolean,
	alignedWithBloom: boolean,
	postMonthly: boolean,
	attendCalls: boolean,
	communityVolunteer: boolean,
	comments: string
) => {
	if (enableLogs) console.log('setSection5Details:ID', id);

	const valid = uuidValidate(id);

	const CLEAN = {
		readIntro,
		understandPlatform,
		signNameAgreement,
		alignedWithBloom,
		postMonthly,
		attendCalls,
		communityVolunteer,
		comments: DOMPurify.sanitize(comments)
	};

	if (valid) {
		if (enableLogs) console.log('setSection3Details:ID:valid');
		const retVal = locationTable('locations').update(CLEAN).match({ id: id }).select();

		if (enableLogs) console.log(retVal);
		return retVal;
	} else {
		if (enableLogs) console.log('setSection3Details:ID:invalid');
		return false;
	}
};

export const getUnpublishedLocations = async () => {
	const { data, error } = await locationTable('locations')
		.select(GET_LIMITED_COL_SET)
		.eq('published', false)
		.order('created_at', { ascending: false });

	if (error) {
		console.error('Error fetching unpublished locations:', error);
		throw error;
	}

	return { data, error };
};

/**
 * setLocationStage: Updates the bloom stage for a location
 * @param id <UUIDv4> ID of the location to update
 * @param stage <string> The stage for this local bloom to set
 * @returns <PostgrestFilterBuilder> | <boolean>false if error
 */
export const setLocationStage = async (id: string, stage: string) => {
	if (!uuidValidate(id)) {
		console.error('Invalid location ID');
		return false;
	}

	const CLEAN = DOMPurify.sanitize(stage);

	return await locationTable('locations').update({ stage: CLEAN }).match({ id: id }).select();
};

/**
 * setLocationContinent: Updates the continent for a location
 * @param id <UUIDv4> ID of the location to update
 * @param continent <string> The continent to set
 * @returns <PostgrestFilterBuilder> | <boolean>false if error
 */
export const setLocationContinent = async (id: string, continent: string) => {
	if (!uuidValidate(id)) {
		console.error('Invalid location ID');
		return false;
	}

	const CLEAN = DOMPurify.sanitize(continent);

	return await locationTable('locations').update({ continent: CLEAN }).match({ id: id }).select();
};

/**
 * setLocationPublished: Updates the published status for a location
 * @param id <UUIDv4> ID of the location to update
 * @param published <boolean> Whether the location should be published (defaults to true)
 * @returns <PostgrestFilterBuilder> | <boolean>false if error
 */
export const setLocationPublished = async (id: string, published: boolean = true) => {
	if (!uuidValidate(id)) {
		console.error('Invalid location ID');
		return false;
	}

	try {
		return await locationTable('locations').update({ published }).match({ id }).select();
	} catch (error) {
		console.error('Error updating location published status:', error);
		return false;
	}
};
